import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M13.5 16a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    <path
      fillRule="evenodd"
      d="M6.25 7v2.25H5A2.75 2.75 0 0 0 2.25 12v8A2.75 2.75 0 0 0 5 22.75h14A2.75 2.75 0 0 0 21.75 20v-8A2.75 2.75 0 0 0 19 9.25h-1.25V7a5.75 5.75 0 0 0-11.5 0M12 2.75A4.25 4.25 0 0 0 7.75 7v2.25h8.5V7A4.25 4.25 0 0 0 12 2.75m-7 8h14c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-8c0-.69.56-1.25 1.25-1.25"
      clipRule="evenodd"
    />
  </>
);

const Lock = Icon('lock', svgContents);

export default Lock;
